import { jsxs, jsx } from "react/jsx-runtime";
import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { Button, token } from "@zillow/constellation";
import { motion } from "framer-motion";
import { yieldCallback } from "@zillow/yield-callback";
const HtmlToReact = require("html-to-react");
const HtmlToReactParser = require("html-to-react").Parser;
const htmlToReactParser = new HtmlToReactParser();
const processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);
const TabButton = styled(Button).withConfig({
  displayName: "CarouselTab__TabButton",
  componentId: "sc-1wlodno-0"
})(["position:relative;&:hover:not(:disabled){background-color:transparent;}&:focus{box-shadow:none;}", ""], (props) => props.isActive ? css(["&:hover:not(:disabled){color:", ";}"], token("colors.brand")) : css(["color:", ";"], token("colors.linkActive")));
const Underline = styled(motion.div).withConfig({
  displayName: "CarouselTab__Underline",
  componentId: "sc-1wlodno-1"
})(["background-color:", ";height:3px;border-radius:3px;width:100%;position:absolute;bottom:0;"], token("colors.brand"));
const UNDERLINE_TRANSITION = {
  layout: {
    duration: 0.2,
    ease: "easeOut"
  }
};
const CarouselTab = ({
  isActive,
  onClick,
  children
}) => {
  const processingInstructions = [{
    shouldProcessNode() {
      return true;
    },
    processNode: processNodeDefinitions.processDefaultNode
  }];
  const parsedChildren = htmlToReactParser.parseWithInstructions(children, () => true, processingInstructions);
  return /* @__PURE__ */ jsxs(TabButton, { bare: true, isActive, onClick: yieldCallback(() => onClick()), children: [
    parsedChildren,
    isActive && /* @__PURE__ */ jsx(Underline, { layout: true, transition: UNDERLINE_TRANSITION, layoutId: "underline" })
  ] });
};
CarouselTab.propTypes = {
  children: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};
CarouselTab.defaultProps = {
  isActive: PropTypes.boolean
};
export {
  CarouselTab as default
};
